export default __webpack_public_path__ + "static/media/Game_1_Sound_Start.ac81061c.wav";